import React, { useEffect, useState } from 'react';
import { fetchOrders } from './api/airtable';
import OrderList from './components/OrderList';
import Login from './components/Login';
import HamburgerMenu from './components/HamburgerMenu';
import './styles/App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFaceGrinWink, faChevronDown } from '@fortawesome/free-solid-svg-icons';

const App = ({ pageTitle }) => {
    const [user, setUser] = useState(null);
    const [orders, setOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [remainingOrders, setRemainingOrders] = useState(0);
    const [selectedCarNumber, setSelectedCarNumber] = useState('');

    const handleLogin = (userData) => {
        localStorage.setItem('loggedInUser', JSON.stringify(userData));
        setUser(userData);
    };

    const handleLogout = () => {
        localStorage.removeItem('loggedInUser');
        setUser(null);
        setOrders([]);
    };

    useEffect(() => {
        const savedUser = localStorage.getItem('loggedInUser');
        if (savedUser) {
            setUser(JSON.parse(savedUser));
        }
    }, []);

    useEffect(() => {
        const getOrders = async () => {
            if (!user) return;
            setIsLoading(true);
        
            let allOrders = await fetchOrders();
            const unwantedStatuses = ["จ่ายแล้ว ส่งแล้ว", "โอนแล้ว ส่งแล้ว", "ไม่ส่ง", "ไม่รับ", "ไม่ตอบ", "ไม่รับเลื่อนส่ง"];
            let filteredOrders = [];
        
            const carNumber = user.userRole === 'god' ? selectedCarNumber : user.carNumber;
        
            // เช็คเวลา
            const now = new Date();
            const currentHours = now.getHours();
            let yesterday;
        
            if (currentHours >= 0 && currentHours < 4) {
                yesterday = new Date(now.setDate(now.getDate() - 1)).toLocaleDateString("th-TH");
            }
        
            // เช็คงานที่มีสถานะที่ยังไม่เสร็จและกำหนดส่งเป็นวันเมื่อวาน
            const hasIncompleteOrders = allOrders.some(order => {
                const orderDate = new Date(order.fields['กำหนดส่ง']).toLocaleDateString("th-TH");
                return !unwantedStatuses.includes(order.fields['สถานะ']) && 
                       (currentHours >= 0 && currentHours < 4 ? orderDate === yesterday : false);
            });
        
            // ถ้ายังมีงานที่ยังไม่เสร็จในวันเมื่อวาน
            if (hasIncompleteOrders) {
                filteredOrders = allOrders.filter(order => {
                    const orderDate = new Date(order.fields['กำหนดส่ง']).toLocaleDateString("th-TH");
                    return orderDate === yesterday && 
                           !unwantedStatuses.includes(order.fields['สถานะ']);
                });
            } else {
                // กรองตามวันปกติ
                const today = new Date().toLocaleDateString("th-TH");
                if (carNumber) {
                    if (user.userRole === 'god') {
                        filteredOrders = allOrders.filter(order =>
                            !unwantedStatuses.includes(order.fields['สถานะ']) &&
                            order.fields['เบอร์รถ'] && order.fields['เบอร์รถ'].trim() === String(carNumber).trim() &&
                            new Date(order.fields['กำหนดส่ง']).toLocaleDateString("th-TH") === today
                        );
                    } else if (user.userRole === 'คนรถ') {
                        filteredOrders = allOrders.filter(order => {
                            const orderDate = new Date(order.fields['กำหนดส่ง']).toLocaleDateString("th-TH");
                            const isCarMatched = order.fields['เบอร์รถ'] && order.fields['เบอร์รถ'].trim() === String(carNumber).trim();
                            const isToday = orderDate === today;
                            return isCarMatched && isToday && !unwantedStatuses.includes(order.fields['สถานะ']);
                        });
                    }
                }
            }
        
            // เรียงตาม `ลำดับส่ง` จากน้อยไปหามาก
            filteredOrders.sort((a, b) => {
                const orderA = a.fields['ลำดับส่ง'] || Infinity;
                const orderB = b.fields['ลำดับส่ง'] || Infinity;
                return orderA - orderB;
            });
        
            setOrders(filteredOrders);
            setIsLoading(false);
        };
        

        getOrders();
    }, [user, selectedCarNumber]);

    // คำนวณจำนวนงานที่ยังค้างอยู่และอัปเดต `remainingOrders`
    useEffect(() => {
        const unwantedStatuses = ["จ่ายแล้ว ส่งแล้ว", "โอนแล้ว ส่งแล้ว", "ไม่ส่ง", "ไม่รับ", "ไม่ตอบ", "ไม่รับเลื่อนส่ง"];
        const remaining = orders.filter(order => !unwantedStatuses.includes(order.fields['สถานะ'])).length;
        setRemainingOrders(remaining);
    }, [orders]);

    const handleCarNumberChange = (e) => {
        setSelectedCarNumber(e.target.value);
    };

    return (
        <div className="App">
            {user ? (
                <div>
                    <HamburgerMenu username={user.username} carNumber={user.carNumber} handleLogout={handleLogout} />
                    <header className="page-header">
                        <h1>
                            {`${pageTitle} รถเบอร์ ${user.userRole === 'god' ? selectedCarNumber : user.carNumber}`}
                            <span className='count'>{remainingOrders > 0 && ` ${remainingOrders}`}</span>
                            {user.userRole === 'god' && (
                                <select value={selectedCarNumber} onChange={handleCarNumberChange}>
                                    <option value="">เลือกเบอร์รถ</option>
                                    {[...Array(10).keys()].map(i => (
                                        <option key={i + 1} value={i + 1}>รถเบอร์ {i + 1}</option>
                                    ))}
                                </select>
                            )}
                        </h1>
                    </header>
                    {isLoading ? (
                        <div className="load-orders-message-container">
                            <FontAwesomeIcon icon={faFaceGrinWink} className="load-orders-icon load-orders-paper" />
                            <p className="load-orders-message">กำลังโหลดงาน...</p>
                        </div>
                    ) : (
                        <OrderList
                            orders={orders}
                            username={user.username}
                            onOrderUpdate={(orderId) => setOrders(orders.filter(order => order.id !== orderId))}
                            shouldRemoveOnUpdate={true}
                        />
                    )}
                </div>
            ) : (
                <Login onLogin={handleLogin} />
            )}
        </div>
    );
};

export default App;
